<template>
  <div class="tuwen">
    <div class='inner-box'>
     <Header v-if="ish5R=='tuwen_d'">
      <h4><span>{{cur_data.chapter_title}}</span></h4>
    </Header>
    
     <div class="con">
        <!-- 图片查看 -->
        <div class="img-wrap" v-if="cur_data.file_path && cur_data.file_path.length>0">
          <div v-for="(item, index) in cur_data.file_path" :key="index" class="img-list" @click="lookBgImg(item)">
              <img :src="item"/>
              <!-- <img src="@/assets/img/picTest/1.jpg"/> -->
              <img src="@/assets/img/h5/img_fd.png" class="enlargement"/>
          </div>
        </div>
       {{cur_data.chapter_content}}
     </div>
    <div class="test_submit" v-if="ish5R=='tuwen_d'">
        <div class="submit_done">
          <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id!=firstChapterId" @click="checkChapter('prev',cur_chap_index,cur_part_index)">上一章节</a>
          <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id==firstChapterId" @click="lookHeadVideo">上一章节</a>
          <a class="next" v-show="cur_data.chapter_id!=lastChapterId" @click="checkChapter('next',cur_chap_index,cur_part_index)">下一章节</a>
          <a class="next" v-show="cur_data.chapter_id==lastChapterId" @click="lookFootVideo">下一章节</a>
        </div>
    </div>
     <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" >
            <v-bg-img :imgSrc="imgActive" v-if="imgActive" @closeImg="closeImg"></v-bg-img>
    </transition>
    </div>
  </div>
</template>

<script>
import Header from 'components/H5/Header.vue'
import mixins from 'components/H5/mixins/compon.js'
import vBgImg from 'components/H5/bgImg.vue'
export default {
  name: "",
  mixins: [mixins],
  data() {
    return {
      ish5R:'', //横竖屏判断
      isShow:true, //未提交 
      imgActive:null,
    }
  },
   computed:{
    cur_data() {
        return this.$store.state.cur_data;
    },
    cur_chap_index(){
        return this.$store.state.currentChapterIndex;
    },
    cur_part_index(){
        return this.$store.state.currentPartIndex;
    },
  },
  created(){
    this.ish5R = this.$route.name;
    this.lastChapterId =  JSON.parse(JSON.stringify(this.data)).part_list[ this.data.part_list.length-1].chapter_list.pop().chapter_id;
    this.firstChapterId =  this.data.part_list[0].chapter_list[0].chapter_id;
    // console.log('最后'+this.lastChapterId)
     /* 存小节学习状态 */
    this.setLessonLocation(this.cur_part_index,this.cur_chap_index)
  },
  mounted(){
    this.$nextTick(()=>{
      $('.minitest').animate({scrollTop:0},50);
      if($('#appH5R')){
        $('#appH5R').animate({scrollTop:0},50);
      }
    })
  },
  watch:{
    cur_data(n_data){
      if(n_data.chapter_type ==4){
        this.setLessonLocation(this.cur_part_index,this.cur_chap_index)
      }
    }
  },
  components: {
    Header,
    vBgImg
  }
}
</script>

<style lang="less" scoped>
    .tuwen {
      font-size:.26rem;
      background: #fff;
      // height:100vh;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      .inner-box {
        // height:auto;
        height:101%;
      }
      .con {
        padding: 0.3rem 0.5rem;
        @media screen and (orientation : landscape){
          padding: 0.3rem 1rem;
        }
        .img-wrap {
          margin-bottom: .5rem;
        }
      }
      .test_submit {
        padding:0.8rem 0.46rem 0.4rem;
        height: 2.2rem;
        box-sizing: border-box;
        .unsubmit {
          /*margin: 40px 0 20px;*/
          img {
            width: 0.22rem;
            height: 0.4rem;
            margin:0.28rem 0.24rem;
          }
          .sub,.next {
            display: inline-block;
            width:0.68rem;
            height:0.96rem;
            border:1px solid rgba(169, 174, 175, 1);
            border-radius:0.06rem;
            margin-right: 0.2rem;
            vertical-align: middle;
            &.yc {
              visibility: hidden;
            }
          }
          .next {
            float: right;
            margin-right: 0;
          }
          .submit {
            display: inline-block;
            width:4.7rem;
            height:1rem;
            background-color: @basic-color;
            border-radius:0.06rem;
            margin: 0 auto;
            font-size:0.3rem;
            color: #fff;
            text-align: center;
            line-height: 1rem;
            vertical-align: middle;
          }
        }
        .submit_done {
          .sub {
            color: @basic-color;
            background-color: #fff;
          }
          .next {
            background-color: #fff;
            color: @basic-color;
            float: right;
          }
          .sub,.next {
            width:3.12rem;
            border:1px solid @basic-color;
            border-radius:0.06rem;
            text-align: center;
            line-height: .78rem;
            display: inline-block;
            font-size: 0.32rem;
            &.cur {
              border:1px solid #ccc;
              color: #ccc;
              opacity:.8;
            }
          }

        }
      }

    }
</style>